import { AppContextData } from '../context'
import { RouteItem } from './RouteItem.types'

const routeFilter = (context: AppContextData, route: RouteItem) => {
    return (
        (!route.grants || context.isGrantedAny(route.grants)) &&
        (!route.exclude || !context.isGrantedAny(route.exclude))
    )
}

const curateRoutes = (
    context: AppContextData,
    routes: RouteItem[]
): RouteItem[] => {
    const curated = routes
        .filter((route: RouteItem) => routeFilter(context, route))
        .map((route) => {
            if (route.items && route.items.length > 0) {
                const curatedItems = curateRoutes(context, route.items)
                return { ...route, items: curatedItems }
            }
            return route
        })

    return curated
}

export { routeFilter, curateRoutes }
